import {
  http,
  addRequestInterceptor,
  addResponseInterceptor
} from '@shared/utils';
import { imageThumb, imageInfo } from '@/utils/image/image';
import { useAccountStore } from '@/store/src/account';
import gconfig from '@/config';

http.setConfig((config) => {
  config.baseURL = gconfig.BASE_API;
  return config;
});
addRequestInterceptor(
  (config) => {
    const $store = useAccountStore();
    if ($store.userInfo.token) {
      config.header.Authorization = 'Bearer ' + $store.userInfo.token;
    }
    return config;
  },
  null,
  {
    runWhen: (config) => {
      const $store = useAccountStore();
      return ($store.userInfo.token ?? '') !== '';
    }
  }
);

// 添加高优先级的响应拦截器处理token更新
addResponseInterceptor(
  (response) => {
    const $store = useAccountStore();
    if (response.header.Authorization) {
      const match = /Bearer\s*(\S+)\b/i.exec(response.header.Authorization);
      if (match && match.length === 2) {
        $store.updateToken(match[1]);
      }
    }
    return response;
  },
  (response) => {
    if (response.statusCode == 402) {
      $store.handleFaceAuthInvalid();
    }
    return response;
  },
  { priority: 100 } // 高优先级，确保在默认拦截器之前执行
);
addResponseInterceptor(
  (response) => {
    return response;
  },
  (response) => {
    return response;
  }
);
const useAxios = (
  { url, method, params },
  { files = [], name = 'file' } = {}
) => {
  if (files.length === 0) {
    return http.request({
      method,
      url,
      params
    });
  } else {
    files.forEach((item) => (item.name = name));
    return http.upload(url, {
      method,
      formData: params,
      name,
      filePath: files[0].uri,
      // #ifdef APP-PLUS || H5
      files
      // #endif
    });
  }
};

const dealImages = (images) => {
  if (!images || images.length == 0)
    return {
      imageList: [],
      videoList: []
    };
  let imageList = [];
  let videoList = [];
  images.map((item) => {
    if (item.type == 'image') {
      let img = imageThumb(item.url, {
        w: 1000
      });
      imageList.push({
        path: img,
        title: item.name
      });
    } else if (item.type == 'video') {
      videoList.push({
        path: item.url,
        ...item
      });
    }
  });
  return {
    imageList,
    videoList
  };
};

const dealData = (data, apiTypeName) => {
  if (Array.isArray(data.data)) {
    data.data.forEach((item) => {
      let { imageList, videoList } = dealImages(item[`${apiTypeName}_files`]);
      item.imageList = imageList;
      item.videoList = videoList;
      item.apiTypeName = apiTypeName;
    });
  } else {
    let { imageList, videoList } = dealImages(data[`${apiTypeName}_files`]);
    data.imageList = imageList;
    data.videoList = videoList;
    data.apiTypeName = apiTypeName;
  }
  return data;
};

// 驼峰转下划线
const toUnderLine = (str) => {
  let temp = str.replace(/([A-Z])/g, '_$1').toLowerCase();
  if (temp.slice(0, 1) === '_') {
    //如果首字母是大写，执行ｒｅｐｌａｃｅ时会多一个_，这里需要去掉
    temp = temp.slice(1);
  }
  return temp;
};

export const useApi = async (
  { url, method, params },
  { files = [], name = 'file' } = {}
) => {
  let urlName = url.split('/');
  let requireURL = '';
  let apiTypeName = 'img';
  if (/^(https?:\/\/)/i.test(url)) {
    requireURL = url;
    return {
      data: await useAxios(
        {
          url: requireURL,
          method,
          params
        },
        {
          files,
          name
        }
      )
    };
  } else {
    requireURL = `/frontend/${urlName[urlName.length - 2]}/${urlName[urlName.length - 1]}`;
    apiTypeName = toUnderLine(urlName[urlName.length - 2]);
    let data = await useAxios(
      {
        url: requireURL,
        method,
        params
      },
      {
        files,
        name
      }
    );

    return {
      data: dealData(data, apiTypeName)
    };
  }
};
